<p class="note">
  {{
    'These advanced settings let you override the default ODIN Voice SDK connection and authentication parameters. Only use these options in development or trusted environments and keep any custom endpoints and keys confidential.'
      | translate
  }}
</p>

<h4>
  <fa-duotone-icon [icon]="faServer"></fa-duotone-icon>
  <span>{{ 'Connection Settings' | translate }}</span>
</h4>

<div class="entry">
  <andor-text-field
    [formControl]="devFormGroup.controls.gateway"
    [placeholder]="defaultGateway"
    [labelTooltip]="
      'The IP address or FQDN and port number of the gateway or server to connect to. Leave empty to use the default.'
        | translate
    "
    [label]="'Custom Server Address' | translate"></andor-text-field>
</div>

<andor-mat-toggle-wrapper
  label="{{ 'Connect to Standalone Server' | translate }}"
  tooltipText="{{
    'Bypass the gateway when running an ODIN on-premise server in standalone mode.' | translate
  }}">
  <mat-slide-toggle
    (toggleChange)="toggleSFUConnection()"
    [checked]="isSFUConnection()"></mat-slide-toggle>
</andor-mat-toggle-wrapper>

<h4>
  <fa-duotone-icon [icon]="faShieldKeyhole"></fa-duotone-icon>
  <span>{{ 'Authentication Settings' | translate }}</span>
</h4>

<div class="entry">
  <andor-text-field
    [formControl]="devFormGroup.controls.accessKey"
    [placeholder]="'Desired Access Key' | translate"
    [labelTooltip]="
      'The access key used to sign JSON Web Tokens for room authentication.' | translate
    "
    [label]="'Custom Access Key' | translate"></andor-text-field>
</div>
